export default __webpack_public_path__ + "static/media/altromLogo.c904155a.svg";